module.exports = __webpack_public_path__ + "img/elecApp.ecdb0a30.png";